import { writable } from 'svelte/store';

export let error = writable("");